export default __webpack_public_path__ + "static/media/question_2_a.65091650.jpg";